import NewsShow from './NewsShow'

export default NewsShow



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/NewsShow/index.js